import {getHexColorsFromString} from './getHexColorsFromString';

/**
 * Check if string is a valid hex color
 * @param str Color string
 * @param ignoreHash Ignore hash
 * @returns Hex color
 *
 * @example
 * ```ts
 * isValidHexColor('#000'); // true
 * isValidHexColor('000000'); // true
 * ```
 */
export const isValidHexColor = (
	str?: string,
	ignoreHash?: boolean,
): str is string => {
	if (str == null) return false;
	if (ignoreHash && str.charAt(0) !== '#') str = `#${str}`;
	return getHexColorsFromString(str) != null;
};

export default isValidHexColor;
